module.exports = __webpack_public_path__ + "img/book7.65d468ac.jpg";